
import api from './api';

class Survey {

	constructor (Api) {
		this.Api = Api;
	}

	all () {
		return this.Api.get({
			url:  'v1.1/m/survey/'
		}).then(response => response.surveys);
	}

	get (surveyId) {
		return this.Api.get({
			url:  'v1.1/m/survey/'+surveyId
		})
			.then(response => response.survey)
			.then(processSurveyParentElements);
	}

	getResponses (surveyId, receiptId) {
		return this.Api.get({
			url:  'v1.1/m/survey/' + surveyId + '/responses/' + receiptId
		})
			.then(response => response.elements)
			.then(elements => processResponses(elements, 'elementId'));
	}

	getStats ({ surveyId, stores, startDate, endDate }) {
		return this.Api.get({
			url:  'v1.1/m/survey/statistics/'+surveyId,
			query: { stores, startDate, endDate }
		}).then(response => response.statistics);
	}

	create (survey) {
		return this.Api.post({
			url:  'v1.1/m/survey/',
			body: survey
		}).then(response => response.survey);
	}

	delete (surveyId) {
		return this.Api.delete({
			url:  'v1.1/m/survey/'+surveyId
		}).then(response => response.survey);
	}

	update (surveyId, survey) {
		return this.Api.put({
			url:  'v1.1/m/survey/'+surveyId,
			body: {
				active: survey.active
			}
		}).then(response => response.survey);
	}

	updateQuestions (surveyId, questions) {
		return this.Api.post({
			url:  'v1.1/m/survey/'+surveyId+'/edit',
			body: {
				questions: processQuestions(questions)
			}
		}).then(response => response.survey);
	}

}

Survey.$inject = ['Api'];

export default angular.module('service.survey', [api])
	.service('Survey', Survey)
	.name;

/*
 * Helpers
 */
function processQuestions (questions) {
	var parentId = null;

	return questions.map(function (q, index) {
		var question = Object.assign({}, q);
		if (question.isChild) {
			question.parentId = parentId;
		} else {
			parentId = index;
			question.parentId = null;
			question.condition = '';
		}
		if (question.condition == 'no' || question.condition == '') {
			question.condition = '';
			question.conditionValue = '';
		}
		delete question.isChild;
		return question;
	});
}

function processSurveyParentElements (s) {
	// add indexes
	const elements = s.elements.map(function (elem, index) {
		return {
			...elem,
			index,
		};
	});

	return {
		...s,
		elements: processResponses(elements, 'index'),
	};
}

function getElements(elements, parentId) {
	return elements.filter(function (elem) {
		return elem.parentId == parentId;
	});
}

function processResponses (elements, key) {
	return getElements(elements, null)

		// reorder children after parents
		.reduce(function (r, elem) {
			return r.concat([elem].concat(
				getElements(elements, elem[key])
			));
		}, [])

		// add is children
		.map(function (elem) {
			elem.isChild = elem.parentId != null;
			delete elem.parentId;
			return elem;
		});
}




// WEBPACK FOOTER //
// ./src/service/survey.js